import { Section } from './section';

export const SECTIONS_WITHOUT_NOTIFICATIONS_BAR = [Section.InstallCode, Section.Onboarding, Section.Subscription];

export const CONTEXT25_CAMPAIGN_DISMISSED_KEY = 'context-25-campaign-dismissed';
export const VISITOR_LIMIT_EXCEEDED_DISMISSED_KEY = 'visitor-limit-exceeded-dismissed';
